import {
  ReportingTab,
  FacultativeTab,
  TreatyTab,
  AgingAnalysisTab,
  AgingAnalysisSummaryTab,
} from "./tabs";
import { OfficeHeader, Tabs } from "components";
import { useUrlState } from "utils";

import { FC } from "react";

type Props = {};

const tabs = [
  { name: "Facultative ", href: "facultative" },
  { name: "Treaty ", href: "treaty" },
  { name: "Aging Analysis", href: "aging_analysis" },
  { name: "Aging Analysis Summary", href: "aging_analysis_summary" },
];

const FinanceReportsPage: FC<Props> = (props) => {
  const [activeTab] = useUrlState("orderStatus");

  return (
    <main className="flex-1 flex flex-col overflow-hidden bg-background-500">
      <OfficeHeader />
      <Tabs tabs={tabs} orderStatus={activeTab} defaultTab={"All"} />
      <div className="flex flex-1 overflow-y-auto">
        <div className="flex-1 mx-auto min-w-0  p-4 sm:py-6 overflow-hidden overflow-y-auto light flex">
          {!activeTab && <ReportingTab />}
          {activeTab === "facultative" && <FacultativeTab />}
          {activeTab === "treaty" && <TreatyTab />}
          {activeTab === "aging_analysis" && <AgingAnalysisTab />}
          {activeTab === "aging_analysis_summary" && (
            <AgingAnalysisSummaryTab />
          )}
        </div>
      </div>
    </main>
  );
};

export default FinanceReportsPage;
